import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppListSearchBtn from '@/components/AppListSearchBtn.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'

import { quoteStatusClassValues } from '@/modules/Quote/helpers/quote'
import RecordTypesHandler from '@/mixins/record-types'
import ListPage from '@/mixins/list-page'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppTextField,
    AppListSearchBtn,
    AppSelector
  }
})
export default class CaseList2 extends mixins(RecordTypesHandler, ListPage) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insurance Cases'
    },
    {
      text: 'Cases2.0'
    }
  ]
  ifRelatedList = false
  quoteStatusOptions = quoteStatusClassValues
}
